import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_ENDPOINTS } from "../config/api";
import "../styles/About.css";

const API = API_ENDPOINTS.ABOUT;

const About = () => {

  const [aboutData, setAboutData] = useState([]);
  const [teamData, setTeamData] = useState([]);
  const [extra, setExtra] = useState(null);

  const [selectedMember, setSelectedMember] = useState(null);

  /* ================= LOAD FROM BACKEND ================= */

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(API);

        if (res.data.data) {
          const d = res.data.data;

          setAboutData(d.aboutData || []);
          setTeamData(d.team || []);

          setExtra({
            ghoshala: d.ghoshala,
            rituals: d.rituals,
            amavasya: d.amavasya,
            dhuni: d.dhuni,
            kumbabishekam: d.kumbabishekam,
          });
        }
      } catch (err) {
        console.error("About API Error:", err);
      }
    };

    fetchData();
  }, []);

  /* ================= LOADING CHECK ================= */

  if (!extra) {
    return <div className="about-page">Loading...</div>;
  }

  return (
    <div className="about-page">

      {/* ================= ABOUT GRID ================= */}
      <section className="about-grid">
        <h2 className="section-title">Om Sai Ram</h2>

        {aboutData.map((item, index) => (
          <React.Fragment key={index}>

            {!item.reverse ? (
              <>
                <div className="grid-text">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>

                <div className="grid-img">
                  <img src={item.img} alt={item.title} />
                </div>
              </>
            ) : (
              <>
                <div className="grid-img">
                  <img src={item.img} alt={item.title} />
                </div>

                <div className="grid-text">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </>
            )}

          </React.Fragment>
        ))}
      </section>

      {/* ================= GHOSHALA ================= */}
      <section className="extra-section">
        <h2 className="section-title">
          {extra.ghoshala?.title}
        </h2>

        <div className="extra-card">
          <img src={extra.ghoshala?.image} alt="Ghoshala" />

          <div>
            <p>{extra.ghoshala?.description}</p>

            <ul>
              {extra.ghoshala?.points?.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ================= DAILY RITUALS ================= */}
      <section className="extra-section alt">
        <h2 className="section-title">Daily Temple Rituals</h2>

        <div className="ritual-grid">

          {extra.rituals?.map((r, i) => (
            <div className="ritual-card" key={i}>
              <img src={r.img} alt={r.title} />
              <h3>{r.title}</h3>
              <p>{r.desc}</p>
            </div>
          ))}

        </div>
      </section>

      {/* ================= AMAVASYA ================= */}
      <section className="extra-section">
        <h2 className="section-title">
          {extra.amavasya?.title}
        </h2>

        <div className="extra-card">
          <img src={extra.amavasya?.image} alt="Amavasya" />

          <div>
            <p>{extra.amavasya?.description}</p>

            <ul>
              {extra.amavasya?.points?.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ================= DHUNI ================= */}
      <section className="extra-section alt">
        <h2 className="section-title">
          {extra.dhuni?.title}
        </h2>

        <div className="extra-card reverse">
          <img src={extra.dhuni?.image} alt="Dhuni" />

          <div>
            <p>{extra.dhuni?.description}</p>

            <ul>
              {extra.dhuni?.points?.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ================= TEAM ================= */}
      {teamData.map((member, index) => (
        <section className="team-section" key={index}>
          <h2 className="section-title">{member.role}</h2>

          <div
            className={`team-container ${
              member.reverse ? "reverse" : ""
            }`}
          >

            <div className="team-image">
              <div className="image-hover">
                <img src={member.img} alt={member.name} />
              </div>

              <div className="image-title">{member.name}</div>
              <div className="image-subtitle">{member.role}</div>
            </div>

            <div className="team-content">
              <p>{member.text}</p>

              <button
                className="team-btn"
                onClick={() => setSelectedMember(member)}
              >
                Learn More
              </button>
            </div>

          </div>
        </section>
      ))}

      {/* ================= POPUP ================= */}
      {selectedMember && (
        <div
          className="popup-overlay"
          onClick={() => setSelectedMember(null)}
        >
          <div
            className="popup-box"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-btn"
              onClick={() => setSelectedMember(null)}
            >
              ✕
            </button>

            <img
              src={selectedMember.img}
              alt={selectedMember.name}
              className="popup-image"
            />

            <h2>{selectedMember.name}</h2>
            <h4>{selectedMember.role}</h4>

            <p>{selectedMember.fullText}</p>
          </div>
        </div>
      )}

      {/* ================= KUMBABISHEKAM ================= */}
      <section className="kumb-section">
        <div className="kumb-container">
          <h3 className="kumb-title">
            {extra.kumbabishekam?.title}
          </h3>

          <p className="kumb-desc">
            {extra.kumbabishekam?.description}
          </p>

          <p className="kumb-date">
            {extra.kumbabishekam?.date}
          </p>

          <p className="kumb-footer">
            {extra.kumbabishekam?.footer}
          </p>
        </div>
      </section>

    </div>
  );
};

export default About;